<template>
  <div class="phone-decorate">
    <div class="phone-decorate-main" ref="main">
      <div class="phone-home">
        <div class="phone-header"></div>
        <div class="banner" :class="isActive?'active':''" @click="banner">
          <el-carousel trigger="click" height="160px">
            <el-carousel-item v-for="(item,index) in images" :key="index">
              <img :src="item.img" alt />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="catalogue">
          <p>
            规制目录
          </p>
        </div>
        <div @click="regulatoryName(index, item)" :class="!isActive&&index==activeIndex?'active':''" class="regulatory-name" v-for="(item, index) in regulatoryNameList" :key="index">
          <div class="left">
            <div class="name">{{ item.name }}</div>
            <div class="time">发布时间：{{ item.time }}</div>
          </div>
          <div class="right">
            <img src="../../../../assets/right-arrow.png" alt="">
          </div>
        </div>
        <div class="add-regulatory" @click="addRegulatory">+增加规制</div>
      </div>
      <div v-if="isBanner" class="decorate">
        <div class="editor">
          <div class="set">
            <svg
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="9897"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="18"
              height="18"
            >
              <path
                d="M1009.152 486.4l-226.304-392.192c-9.216-15.872-26.112-25.6-44.544-25.6H285.696c-18.432 0-35.328 9.728-44.544 25.6L14.848 486.4c-9.216 15.872-9.216 35.328 0 51.2l226.304 392.192c9.216 15.872 26.112 25.6 44.544 25.6h453.12c18.432 0 35.328-9.728 44.544-25.6l226.304-392.192c8.704-15.872 8.704-35.328-0.512-51.2z m-276.48 407.552H291.328l-220.16-381.952L291.84 130.048h440.832l220.672 381.952-220.672 381.952z"
                fill="#1296db"
                p-id="9898"
              />
              <path
                d="M512 332.8c-98.816 0-179.2 80.384-179.2 179.2s80.384 179.2 179.2 179.2 179.2-80.384 179.2-179.2-80.384-179.2-179.2-179.2z m0 296.96c-65.024 0-117.76-52.736-117.76-117.76s52.736-117.76 117.76-117.76 117.76 52.736 117.76 117.76-52.736 117.76-117.76 117.76z"
                fill="#1296db"
                p-id="9899"
              />
            </svg>
          </div>
          <div class="remove-up" @click="upImg">
            <svg
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="1835"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="18"
              height="18"
            >
              <path
                :fill="imgEditorIndex ===0 ||imgEditorIndex ===''?'#eeeeee':'#999999'"
                d="M907.955934 352.01498L563.195206 7.254252a24.183503 24.183503 0 0 0-7.565833-5.089161c-0.087882-0.039946-0.167775-0.095871-0.263646-0.135818a24.071654 24.071654 0 0 0-3.890771-1.206379c-0.239678-0.055925-0.463377-0.159785-0.711045-0.207721-1.597853-0.319571-3.219674-0.487345-4.833505-0.487345H497.139968a24.279375 24.279375 0 0 0-19.669569 10.090441L135.65771 352.01498a24.367256 24.367256 0 0 0 0 34.473676l34.473676 34.481665a24.383235 24.383235 0 0 0 34.473676 0l268.151671-268.15966V999.616765a24.375246 24.375246 0 0 0 24.383235 24.383235h48.758481a24.375246 24.375246 0 0 0 24.375246-24.383235V152.243423l268.726898 268.726898a24.383235 24.383235 0 0 0 34.473676 0l34.473676-34.481665a24.367256 24.367256 0 0 0 0.007989-34.473676z"
                p-id="1836"
              />
            </svg>
          </div>
          <div class="remove-down" @click="downImg">
            <svg
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="1389"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="18"
              height="18"
            >
              <path
                :fill="imgEditorIndex ===images.length-1||imgEditorIndex ===''?'#eeeeee':'#999999'"
                d="M116.044066 671.98502L460.804794 1016.745748a24.183503 24.183503 0 0 0 7.565833 5.089161c0.087882 0.039946 0.167775 0.09587099 0.263646 0.135818a24.071654 24.071654 0 0 0 3.89077101 1.206379c0.239678 0.055925 0.463377 0.159785 0.71104499 0.207721 1.597853 0.319571 3.21967399 0.487345 4.833505 0.487345L526.860032 1023.872172a24.279375 24.279375 0 0 0 19.66956899-10.090441L888.34229001 671.98502a24.367256 24.367256 0 0 0-1e-8-34.473676l-34.47367601-34.481665a24.383235 24.383235 0 0 0-34.47367599 0l-268.151671 268.15966L551.243267 24.383235a24.375246 24.375246 0 0 0-24.383235-24.383235l-48.758481 0a24.375246 24.375246 0 0 0-24.375246 24.383235L453.726305 871.756577l-268.726898-268.726898a24.383235 24.383235 0 0 0-34.47367599 0l-34.47367601 34.481665a24.367256 24.367256 0 0 0-0.007989 34.473676z"
                p-id="1390"
              />
            </svg>
          </div>
          <div class="remove" @click="removeImg">
            <svg
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="2557"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="18"
              height="18"
            >
              <path
                d="M519.669429 0c-104.534771 0-189.591705 82.942197-193.175627 186.875937H82.586757A49.195452 49.195452 0 0 0 33.391304 236.026869a49.195452 49.195452 0 0 0 49.195453 49.150931h54.315341v550.900024C136.902098 939.499576 207.111354 1023.97774 293.704254 1023.97774h441.690572c86.5929 0 156.802156-83.966175 156.802156-187.899916V285.689789h49.195453A49.195452 49.195452 0 0 0 990.587887 236.538858a49.195452 49.195452 0 0 0-49.195452-49.150932H712.333066A192.663638 192.663638 0 0 0 519.691689 0zM411.81786 178.083085c3.561662-50.063607 46.902633-89.041543 100.4166-89.041542C565.770687 89.041543 609.111658 128.019478 612.161331 178.083085h-200.343471z m-112.637551 756.341123c-31.16454 0-65.445534-39.356362-65.445534-95.586096V289.385013h578.770027v549.965088C812.504802 895.579835 778.223808 934.936197 747.059268 934.936197H299.180309v-0.511989z"
                :fill="imgEditorIndex ===''?'#eeeeee':'#999999'"
                p-id="2558"
              />
              <path
                d="M367.297089 801.373883c24.486424 0 44.520771-21.815178 44.520771-49.106411V472.053738C411.81786 444.762505 391.783513 422.947327 367.297089 422.947327s-44.520771 21.815178-44.520771 49.106411v280.213734C322.776318 779.558705 342.254155 801.373883 367.297089 801.373883z m155.8227 0c24.486424 0 44.520771-21.815178 44.520771-49.106411V472.053738C567.64056 444.762505 547.606213 422.947327 523.119789 422.947327s-44.520771 21.815178-44.520772 49.106411v280.213734C478.599017 779.558705 498.633364 801.373883 523.119789 801.373883z m133.562313 0c24.486424 0 44.520771-21.815178 44.520772-49.106411V472.053738C701.202874 444.762505 681.168527 422.947327 656.682102 422.947327s-44.520771 21.815178-44.520771 49.106411v280.213734C612.161331 779.558705 631.639169 801.373883 656.682102 801.373883z"
                :fill="imgEditorIndex ===''?'#eeeeee':'#999999'"
                p-id="2559"
              />
            </svg>
          </div>
        </div>
        <div class="img-setting">
          <div class="title">
            <span>Banner模块</span>
          </div>
          <div class="img-upload">
            <p class="explain">建议图片尺寸为750*292px，支持jpg、png格式，最多上传6张图片</p>
            <div class="upload">
              <el-upload
                action="#"
                list-type="picture-card"
                :auto-upload="true"
                :before-upload="beforeUpload"
                :file-list="fileList"
                :limit="limit"
                :disabled="limit === -1?true:false"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </div>
          <div class="auto">
            <div class="img-container">
              <div class="img-content" v-for="(value,index) in images" :key="index">
                <div
                  :class="imgEditorIndex === index ?'img imgEditor':'img'"
                  @click="imgEditor(index)"
                >
                  <img :src="value.img" alt />
                </div>
                <div class="link">
                  <span class="text">链接：</span>
                  <el-input class="white" v-model="value.link"></el-input>
                </div>
              </div>
            </div>
            <div class="btn">
              <el-button class="btn-blue" @click="saveBanner">保存</el-button>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="product-details">
        <div class="editor">
          <div class="set">
            <svg
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="9897"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="18"
              height="18"
            >
              <path
                d="M1009.152 486.4l-226.304-392.192c-9.216-15.872-26.112-25.6-44.544-25.6H285.696c-18.432 0-35.328 9.728-44.544 25.6L14.848 486.4c-9.216 15.872-9.216 35.328 0 51.2l226.304 392.192c9.216 15.872 26.112 25.6 44.544 25.6h453.12c18.432 0 35.328-9.728 44.544-25.6l226.304-392.192c8.704-15.872 8.704-35.328-0.512-51.2z m-276.48 407.552H291.328l-220.16-381.952L291.84 130.048h440.832l220.672 381.952-220.672 381.952z"
                fill="#1296db"
                p-id="9898"
              />
              <path
                d="M512 332.8c-98.816 0-179.2 80.384-179.2 179.2s80.384 179.2 179.2 179.2 179.2-80.384 179.2-179.2-80.384-179.2-179.2-179.2z m0 296.96c-65.024 0-117.76-52.736-117.76-117.76s52.736-117.76 117.76-117.76 117.76 52.736 117.76 117.76-52.736 117.76-117.76 117.76z"
                fill="#1296db"
                p-id="9899"
              />
            </svg>
          </div>
          <div class="remove" @click="removeImg">
            <svg
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="2557"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="18"
              height="18"
            >
              <path
                d="M519.669429 0c-104.534771 0-189.591705 82.942197-193.175627 186.875937H82.586757A49.195452 49.195452 0 0 0 33.391304 236.026869a49.195452 49.195452 0 0 0 49.195453 49.150931h54.315341v550.900024C136.902098 939.499576 207.111354 1023.97774 293.704254 1023.97774h441.690572c86.5929 0 156.802156-83.966175 156.802156-187.899916V285.689789h49.195453A49.195452 49.195452 0 0 0 990.587887 236.538858a49.195452 49.195452 0 0 0-49.195452-49.150932H712.333066A192.663638 192.663638 0 0 0 519.691689 0zM411.81786 178.083085c3.561662-50.063607 46.902633-89.041543 100.4166-89.041542C565.770687 89.041543 609.111658 128.019478 612.161331 178.083085h-200.343471z m-112.637551 756.341123c-31.16454 0-65.445534-39.356362-65.445534-95.586096V289.385013h578.770027v549.965088C812.504802 895.579835 778.223808 934.936197 747.059268 934.936197H299.180309v-0.511989z"
                :fill="imgEditorIndex ===''?'#eeeeee':'#999999'"
                p-id="2558"
              />
              <path
                d="M367.297089 801.373883c24.486424 0 44.520771-21.815178 44.520771-49.106411V472.053738C411.81786 444.762505 391.783513 422.947327 367.297089 422.947327s-44.520771 21.815178-44.520771 49.106411v280.213734C322.776318 779.558705 342.254155 801.373883 367.297089 801.373883z m155.8227 0c24.486424 0 44.520771-21.815178 44.520771-49.106411V472.053738C567.64056 444.762505 547.606213 422.947327 523.119789 422.947327s-44.520771 21.815178-44.520772 49.106411v280.213734C478.599017 779.558705 498.633364 801.373883 523.119789 801.373883z m133.562313 0c24.486424 0 44.520771-21.815178 44.520772-49.106411V472.053738C701.202874 444.762505 681.168527 422.947327 656.682102 422.947327s-44.520771 21.815178-44.520771 49.106411v280.213734C612.161331 779.558705 631.639169 801.373883 656.682102 801.373883z"
                :fill="imgEditorIndex ===''?'#eeeeee':'#999999'"
                p-id="2559"
              />
            </svg>
          </div>
        </div>
        <div class="rugelatory-container">
          <div class="title">{{ title }}</div>
          <div class="sub-title">
            <el-input
              v-model="subTitle"
              clearable
              class="gray white"
            ></el-input>
          </div>
          <div class="editor-container" ref="editor">
            <editor :catchData="catchData" :content="content"></editor>
          </div>
          <div class="foot">
            <el-button class="btn-blue" @click="save">发布</el-button>
          </div>
        </div>
      </div>
    </div>

    
    <!-- 选择分类 -->
    <el-dialog
      title="选择分组"
      :visible.sync="dialogVisible"
      width="540px"
      :before-close="handleClose"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item
          label="规制分类名"
          prop="ruleCategory"
        >
          <el-select
            v-model="form.ruleCategory"
            placeholder="请选择"
            class="gray white"
          >
            <el-option
              v-for="item in ruleCategoryList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="confirm('form')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Editor from "@/components/Editor";
import { config } from "@/common/js/config.js";
import { formatTimeToDate } from '@/common/js/utils.js'
import ImgUploader from "@/models/img-upload.js";
const imgUploader = new ImgUploader();
export default {
  data() {
    return {
      fileList: [],
      images: [],
      imgEditorIndex: "",
      regulatoryNameList: [
        {id: 1, name: '《关于财务人员技能培训通知》', time: '2021-06-07', content: '', contentDatails: ''}
      ],
      isBanner: true,
      content: '',
      isActive: true,
      activeIndex: 0,
      subTitle: '',
      title: '规制文本模块',
      dd: '布鲁姆教学目标模型',
      tt: '需求调查与分析',
      id: null,
      isAdd: false,

      dialogVisible: false,
      form: {
        ruleCategory: ''
      },
      ruleCategoryList: [
        {id:1, name: '班级制度'},
        {id:2, name: '通知类'},
        {id:3, name: '工作流程类'}
      ],
      rules: {
        ruleCategory: [
          { required: true, message: "请选择规制分类名", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    limit() {
      return 5 - this.images.length;
    }
  },
  components: {
    Editor
  },
  created() {
    config();
    this.getBannerData();
    this.initEditer()
    window.unscramble = (e) => {
      this.content = this.regulatoryNameList[this.activeIndex].contentDatails
      this.title = '解读模块'
      this.subTitle = e
      if (e == '布鲁姆教学目标模型') {
        this.content = `<p>布鲁姆教育目标分类法是一种教育的分类方法。教育目标可分为三大领域：认知领域、情感领域和动作技
                能领域。</p>`
      }
    }
  },
  methods: {
    // 富文本编辑器内容
    catchData(value) {
      this.content = value; // 在这里接受子组件传过来的参数，赋值给data里的参数
    },
    initEditer() {
      let t = '布鲁姆教学目标模型'
      let dfga = '需求调查与分析'
      let d = `<p style="font-style: normal; font-variant-ligatures: normal; 
      font-variant-caps: normal; font-weight: 400; font-family: &quot;Microsoft YaHei&quot;, 
      tahoma, arial, &quot;Hiragino Sans&quot;; letter-spacing: 1px;"><span style="color: rgb(96, 98, 102);">
      为什么做这个培训，是目前员工在财务的某个环节（例如：报销）出现了什么问题，还是员工没有成本意识，还<br/>是其他什么？正所谓，做事不由东
      ，累死也无功。不了解领导的想法，随随便便就把培训做了，等着挨批吧。希望<br/>通过这个培训达到什么样的结果，可以参考
      </span><font color="#46acc8" style="cursor: pointer;" onclick="unscramble('${t}')">布鲁姆教学目标模型</font><font color="#606266">。
      包括：记忆、理解、应用、分析、评价、创造。不</font></p><p style="font-style: normal; font-variant-ligatures: normal; 
      font-variant-caps: normal; font-weight: 400; font-family: &quot;Microsoft YaHei&quot;, tahoma, arial, &quot;Hiragino 
      Sans&quot;; letter-spacing: 1px;"><span style="color: rgb(96, 98, 102);">同的目标，会决定你的内容、课程设计环节的差异。
      具体的这里就不展开了，可以百度一下。从上一步其实已经<br/>能够大概的分析出主要的讲授方向和大致内容了。但是还缺一步，就是去了解你的目标学员现状
      ，即：针对你<br/>要讲的这个课题，他们目前的财务水平是什么样的、他们的工作中与你要讲解的财务课题关联度在哪？实际工<br/>作中，在哪个环节、
      哪件事上经常出现问题。也就是说，你要像一个老中医那样，先问问病人的过往病史、发病过<br/>程，然后才能确定病因，再开药。我们专业名词叫：
      </span><font color="#46acc8" style="cursor: pointer;" onclick="unscramble('${dfga}')">需求调查与分析</font><font color="#606266">。通过这两步，
      基本上就能锁定你到底要讲</font></p><p style="font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; 
      font-weight: 400; font-family: &quot;Microsoft YaHei&quot;, tahoma, arial, &quot;Hiragino Sans&quot;; 
      color: rgb(96, 98, 102); letter-spacing: 1px;">什么、讲到什么程度了。过往很多培训被老板抱怨无效
      ，是因为缺少了需求分析、或分析的不够彻底。导致提供<br/>的内容，要么太深，听不懂；要么太浅，大家都会，还重复讲；要么过于理论
      ，与实际工作关联的少。接下来，结<br/>合布鲁姆的目标模型，就可以去设计你的课件了，到底讲哪些、讲到什么程度、设置什么样的学
      习活动......<br/>课件基本就出来了。<br/>不知道你们全公司的人员有多少，如果人数角度，就涉及到要怎么开展培训？是线上还是线下。具体到
      一个时<br/>间点，或者一个时间周期。公司是否有培训教室、会议室。如果没有，可能需要外租场地，在哪租，路程等等就需<br/>要考虑了。这次培训
      是否有费用，特别是需要外租场地的，预算多少一定程度也限制了你的解决方案。如果没有<br/>预算，可能就要改成线上。那么线上培训使
      用什么软件（how的环节需要思考），免费软件还是付费......</p>`
      this.content = d
      this.regulatoryNameList[0].content = d
      // this.getJsonp(d)
    },
    save() {
      if (this.title != '解读模块') {
        if (this.isAdd) {
          let obj = {
            id: this.id,
            name: this.subTitle,
            time: formatTimeToDate(''),
            content: this.content,
            contentDatails: ''
          }
          this.regulatoryNameList.unshift(obj)
          this.isAdd = false
          this.isBanner = true
        }
      } else {
        this.regulatoryNameList[this.activeIndex].contentDatails = this.content
      }
    },
    // jsonp
    getJsonp(url) {
      if (url) {
        var hash = new Date().getTime();
        let script = document.createElement("script");
        this.content = "";
        script.src = url + `?hash=${hash}`;
        document.body.appendChild(script);
        window.jsonpCallBack = (response) => {
          let str = response.content;
          this.ruleForm.content = str;
          this.content = str;
        };
        script.onload = function (e) {
          e.currentTarget.remove();
          delete window.jsonpCallBack;
        };
        script.onerror = function (e) {
          alert("数据请求失败");
          e.currentTarget.remove();
          delete window.jsonpCallBack;
        };
        window.jsonpCallback = (response) => {
          console.log(response);
          let str = response.content;
          this.ruleForm.content = str;
          this.content = str;
        };
        script.onload = function (e) {
          e.currentTarget.remove();
          delete window.jsonpCallback;
        };
        script.onerror = function (e) {
          alert("数据请求失败");
          e.currentTarget.remove();
          delete window.jsonpCallback;
        };
      }
    },
    banner() {
      this.isBanner = true
      this.isActive = true
    },
    regulatoryName(index, item) {
      this.title = '规制文本模块'
      this.subTitle = item.name
      this.isBanner = false
      this.isActive = false
      this.activeIndex = index
      this.content = item.content
      // this.initEditer()
    },
    addRegulatory() {
      this.dialogVisible = true
    },
    // 获取当前数据
    getBannerData() {
      // dbMall.getDBBannerList().then(res => {
      //   if (res.success) {
          let arr = [];
          let d = [
            {pic: require('../../../../assets/phone-bg.png'), url: 'src/assets/phone-bg.png'}
          ]
          // res.result.map(value => {
          d.map(value => {
            let obj = {};
            obj.img = value.pic;
            obj.link = value.url;
            arr.push(obj);
          });
          this.images = arr;
      //   }
      // });
    },
    // 上传图片进行判断图片
    beforeUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/bmp" ||
        file.type === "image/jpg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传图片格式错误!");
        return false;
      } else if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return false;
      } else {
        this.file = file;
        imgUploader
          .postImgUpload(this.file)
          .then(res => {
            if (res.errorCode === 0) {
              let obj = {};
              obj.img = res.imgUrl;
              obj.link = "";
              this.images.push(obj);
            } else {
              this.$message.error("图片上传超时，请重新上传");
            }
          })
          .catch(() => {
            this.$message.error("图片上传超时，请重新上传");
          });
        return false;
      }
    },
    // 选中图片
    imgEditor(index) {
      if (this.imgEditorIndex === index) {
        this.imgEditorIndex = "";
      } else {
        this.imgEditorIndex = index;
      }
    },
    // 上移选中的图片
    upImg() {
      if (this.imgEditorIndex === "") {
        console.log("请选择图片");
      } else {
        if (this.imgEditorIndex === 0) {
          console.log("该图片已是第一个图片");
        } else {
          let obj = this.images[this.imgEditorIndex];
          this.images.splice(this.imgEditorIndex, 1);
          this.images.splice(this.imgEditorIndex - 1, 0, obj);
          this.imgEditorIndex -= 1;
        }
      }
    },
    // 下移选中的图片
    downImg() {
      if (this.imgEditorIndex === "") {
        console.log("请选择图片");
      } else {
        if (this.imgEditorIndex === this.images.length - 1) {
          console.log("该图片已是最后一个图片");
        } else {
          let obj = this.images[this.imgEditorIndex];
          this.images.splice(this.imgEditorIndex, 1);
          this.images.splice(this.imgEditorIndex + 1, 0, obj);
          this.imgEditorIndex += 1;
        }
      }
    },
    // 删除选中的图片
    removeImg() {
      if (this.imgEditorIndex === "") {
        console.log("请选择图片");
      } else {
        this.images.splice(this.imgEditorIndex, 1);
      }
    },
    // 保存
    saveBanner() {
      let data = [];
      this.images.map(value => {
        let obj = {};
        obj.pic = value.img;
        obj.url = value.link;
        data.push(obj);
      });
      // dbMall.postDBUpdateBanner(data).then(res => {
      //   if (res.success) {
          this.$message.success("保存成功");
      //   }
      // });
    },

    handleClose() {
      this.form.ruleCategory = ''
      this.dialogVisible = false
    },
    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let id = this.regulatoryNameList[this.regulatoryNameList.length-1].id
          id += 1
          this.id = id
          this.isBanner = false
          this.title = '规制文本模块'
          this.subTitle = ''
          this.content = ''
          this.isAdd = true
          this.handleClose();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>
<style lang='scss' scoped>
.phone-decorate {
  flex: 1;
  width: 100%;
  background: $bg-white;
  border-radius: 8px;
  padding: 20px;
  box-sizing: border-box;
  .phone-decorate-main {
    height: 100%;
    display: flex;
    .phone-home {
      width: 375px;
      height: 100%;
      box-shadow: 0px 3px 7px 0px rgba(35, 52, 70, 0.12);
      background: $bg-ChangeDepartmentTree;
      .phone-header {
        height: 44px;
        font-size: $fs-medium-s;
        line-height: 44px;
        text-align: center;
        color: $color-grey;
        background: url('../../../../assets/phone-menu.png') center no-repeat;
      }
      .banner {
        height: 160px;
        img {
          width: 100%;
          height: 160px;
        }
      }
      .catalogue {
        font-size: $fs-medium-m;
        font-weight: bold;
        color: $color-Step;
        padding: 0px 9px;
        background: $bg-white;
        p {
          height: 48px;
          line-height: 48px;
          border-bottom: 1px solid $bg-ShallowLightSnow;
        }
      }
      .regulatory-name {
        height: 68px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0px 20px 0px 9px;
        border-bottom: 1px solid $bg-ShallowLightSnow;
        background: $bg-white;
        .name {
          text-align: left;
          font-size: 17px;
          font-weight: 400;
          color: $color-Step;
          margin-bottom: 9px;
        }
        .time {
          text-align: left;
          font-size: $fs-small-m;
          font-weight: 400;
          color: rgb(171,171,171);
          padding-left: 10px;
        }
        .right {
          width: 7px;
          height: 11px;
        }
      }
      .add-regulatory {
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: $color-DeepReddishBlue;
        font-size: $fs-small-l;
        background: $bg-white;
      }
    }
    .decorate {
      margin-left: 16px;
      height: 100%;
      width: 398px;
      display: flex;
      justify-content: space-between;
      .editor {
        width: 32px;
        height: 145px;
        background: $bg-white;
        box-shadow: 0px 3px 7px 0px rgba(35, 52, 70, 0.12);
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: space-evenly;
      }
      .img-setting {
        width: 350px;
        height: 100%;
        padding-bottom: 40px;
        box-sizing: border-box;
        background: $bg-white;
        box-shadow: 0px 3px 7px 0px rgba(35, 52, 70, 0.12);
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        position: relative;
        .title {
          padding: 0 16px;
          box-sizing: border-box;
          width: 100%;
          height: 44px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid rgba(238, 238, 238, 1);
        }
        .img-upload {
          width: 100%;
          box-sizing: border-box;
          padding: 0 16px;
          font-size: $fs-small-l;
          color: $color-LightGrey;
          .img-content {
            padding: 8px 0;
            .blue {
              color: $color-DepartmentPeople;
            }
          }
          .explain {
            text-align: left;
            font-size: $fs-small-m;
            line-height: 18px;
            margin-bottom: 12px;
            margin-top: 16px;
          }
        }
        .auto {
          overflow: auto;
          flex: 1;
          width: 100%;
          box-sizing: border-box;
          padding: 0 16px;
          .img-container {
            width: 100%;
            min-height: 100px;
            .img-content {
              padding-top: 10px;
              padding-bottom: 10px;
              border-bottom: 1px solid $bg-ShallowLightSnow;
              .img {
                width: 100%;
                height: 140px;
                box-sizing: border-box;
                margin-bottom: 12px;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
              .imgEditor {
                box-sizing: border-box;
                border: 2px solid $color-DepartmentPeople;
              }
              .link {
                display: flex;
                align-items: center;
                .text {
                  display: block;
                  width: 75px;
                  font-size: $fs-small-l;
                }
              }
            }
          }
          .btn {
            left: 50%;
            margin-left: -32px;
            justify-content: center;
            display: flex;
            position: absolute;
            bottom: 6px;
            .el-button {
              width: 64px;
              height: 28px;
              font-size: $fs-small-m;
            }
          }
        }
        .auto::-webkit-scrollbar {
          /*滚动条整体样式*/
          width: 7px; /*高宽分别对应横竖滚动条的尺寸*/
          height: 1px;
        }
        .auto::-webkit-scrollbar-thumb {
          /*滚动条里面小方块*/
          border-radius: 7px;
          box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          background: #ccc;
        }
        .auto::-webkit-scrollbar-track {
          /*滚动条里面轨道*/
          box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          border-radius: 10px;
          background: #ededed;
        }
      }
    }
  }
  .active {
    border: 1px solid red!important;
  }
}
</style>
<style lang='scss'>
.phone-decorate {
  .el-carousel__indicators {
    display: none;
  }
  .upload {
    padding-bottom: 16px;
    .el-upload {
      width: 100%;
      height: 140px;
      background: rgba(246, 246, 246, 1);
      border: 0;
    }
  }
  .sub-title {
    margin-top: 16px;
    font-size: $fs-small-l;
    font-weight: 400;
    color: rgb(137,137,137);
  }
  .product-details {
    width: 700px;
    display: flex;
    justify-content: space-between;
    .editor {
      width: 32px;
      height: 80px;
      margin: 0px 16px;
      padding: 0px 6px;
      background: $bg-white;
      box-shadow: 0px 3px 7px 0px rgba(35, 52, 70, 0.12);
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: space-evenly;
    }
    .rugelatory-container {
      padding: 15px;
      box-shadow: 0px 3px 7px 0px rgba(35, 52, 70, 0.12);
      position: relative;
    }
    .editor-container {
      width: 100%;
      padding: 24px 0px 0 0px;
    }
    .foot {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 64px;
      border-top: 1px solid $bg-ShallowLightSnow;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>